
<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- Carga el compononte para activar modal de  ver calendario -->
    <CalendarioAlumno></CalendarioAlumno>

    <!-- boton crear -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">

        <ButtonComp v-if="componenteEvento.visualizar_submodulo" @click="generarExcel" textButton="Descargar horario"
          iconBut="fa fa-file-excel" normalButton />
        <ButtonComp v-if="componenteEvento.visualizar_submodulo" @click="verCalendario" textButton="Ver calendario"
          iconBut="fas fa-calendar" normalButton classButton="ml-2" />
      </v-col>

      <v-col cols="12">
        <ComundataTablecomp :headers="MisclasesAlumnoHeader" :items="filteredData" whitSearch :search="search">
          <template v-slot>
            <v-row class="d-flex align-center justify-center">
              <v-col cols="12" md="2">
                <ButtonComp icon-but="fas fa-sync-alt" @click="loadMain()" classColor="primary"
                  tooltipText="Recargar los filtros" />
              </v-col>
              <v-col cols="12" md="5">
                <AutocompleteComp textLabel="Área" v-model="filtroProgAlum.id_area" :items="areaAlumno"
                  item-value="id_area_mant" item-text="desc_area" @change="eventAreaAlum" />
              </v-col>
              <v-col cols="12" md="5">
                <AutocompleteComp textLabel="Curso" v-model="filtroProgAlum.id_curso" :items="cursoAlumFilter"
                  :isDisable="inhabilitarCursoAlum" item-value="id_curso" item-text="desc_curso"
                  @change="eventCursoAlum" />
              </v-col>
            </v-row>

          </template>
          <template v-slot:desc_curso="{ item }">
            <v-chip class="pr-0 pl-2" color="white">
              <v-icon left small :color="item.color_curso">{{ item.icono_curso }}</v-icon>
              {{
                item.desc_curso
              }}
            </v-chip>
          </template>
          <template v-slot:fecha="{ item }">
            <span>{{ item.fecha | filtroFecha }}</span>
          </template>
          <template v-slot:hora_inicio="{ item }">
            {{ item.hora_inicio | filtroFormatoHora }}
          </template>
          <template v-slot:hora_fin="{ item }">
            {{ item.hora_fin | filtroFormatoHora }}
          </template>
          <template v-slot:desc_estado="{ item }">
            <v-chip small dark class="font-weight-black" :color="item.color_estado">
              {{ item.desc_estado }}
            </v-chip>
          </template>
          <template v-slot:somos_habiles="{ item }">
              <v-tooltip right :color="item.estado_examen === null && item.fecha_inicio_examen === null ? 'red' : !item.estado_examen && item.fecha_inicio_examen ? 'green' : !item.estado_examen && item.fecha_inicio_examen === null ? 'warning' : 'primary'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="(componenteEvento.visualizar_submodulo && item.res_visualizar_cont_alumno_prog_doc == 0) || (componenteEvento.visualizar_submodulo && item.res_visualizar_cont_alumno_prog_doc == 1 && item.id_estado == 4)"
                      v-on="on"
                      :color="item.estado_examen === null && item.fecha_inicio_examen === null ? 'red' : !item.estado_examen && item.fecha_inicio_examen ? 'green' : !item.estado_examen && item.fecha_inicio_examen === null ? 'warning' : 'primary'"
                      :disabled="item.desc_estado == 'Ejecutada' ? false : true"
                      class="px-0 mx-0"
                      icon
                      small
                      @click="visualizarSomosHabiles(item)"
                    >
                      <v-icon small>fa fa-book</v-icon>
                    </v-btn>
                  </template>
                  <span> {{ item.estado_examen === null && item.fecha_inicio_examen === null ? 'No existe somos hábiles' : !item.estado_examen && item.fecha_inicio_examen ? 'Somos hábiles resuelto' : !item.estado_examen && item.fecha_inicio_examen === null ? 'Somos hábiles caducado' : 'Iniciar somos hábiles' }} </span>
                </v-tooltip>

          </template>
          <template v-slot:ver_clase="{ item }">
            <ButtonComp
              v-if="(componenteEvento.visualizar_submodulo && item.res_visualizar_cont_alumno_prog_doc == 0) || (componenteEvento.visualizar_submodulo && item.res_visualizar_cont_alumno_prog_doc == 1 && item.id_estado == 4)"
              @click="visualizarClase(item.id_clase, item.tipo_contenido)" verButton tooltipText="Ver clase" />
          </template>


          <template v-slot:ing_clase_virt="{ item }">
            <ButtonComp v-if="componenteEvento.visualizar_submodulo && item.clase_virtual"
              @click="validarEnlace(item.enlace_virtual, item.fecha, item.hora_inicio, item.hora_fin, item.id_estado)"
              :disabled="item.id_estado == 3 || item.id_estado == 4" cameraButton tooltipText="Ver clase virtual" />
            <ButtonComp v-if="item.clase_virtual == 0" disabled cameraButton />

          </template>

          <template v-slot:grabac_clase="{ item }">
            <ButtonComp v-if="componenteEvento.visualizar_submodulo && item.clase_virtual_video == 1" playButton
              :href="item.clase_virtual_video_enlace" tooltipText="Ver video de clase grabada" />
            <ButtonComp v-if="item.clase_virtual_video == 0" disabled tooltipText="No tiene video de clase grabada"
              playButton />

          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>


    <!-- MODAL VISOR DE CONTENIDOS-->
    <v-dialog v-model="visor" scrollable max-width="80%">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row class="d-flex justify-space-between py-0">
            Contenido
            <v-btn fab dark x-small class="btn_style3" @click="cerrarVisor"><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="text-center">
          <component :is="tipoVisor" :diapositivas="api_list_contenidos"></component>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbarGlobal" :color="colorsnackbarGlobal" multi-line :timeout="timeout" top>
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-alert-circle-outline</v-icon>
        <v-layout column>
          <div>
            <strong> {{ textAlertGlobal }} </strong>
          </div>
        </v-layout>
      </v-layout>
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarGlobal = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <component :is="compNameDialog" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal"
      @reload="loadMain()">
    </component>

  </div>
</template>

<script>
// import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios, { BUCKET_ORIGIN_SPACE, API_URL } from "../../../helpers/axios";
import { mapMutations, mapGetters, mapActions, } from "vuex";
import CalendarioAlumno from "./components/Calendario.vue";
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from "../../../components/ComponentsEst/AutocompleteComp.vue";
import VisorContenido from '@/views/Manager/GestionContenido/viewGC/visorGestorContenido';
import { MisclasesAlumnoHeader } from "../../../helpers/headersTable";
import io from 'socket.io-client';
// import VisorContenidoColegio from '@/views/Manager/GestionContenido/viewGC/visorGestorContenidoColegio';

import moment from "moment";

export default {
  name: "clasesAlumno",

  components: {
    CalendarioAlumno,
    VisorContenido,
    ComundataTablecomp,
    ButtonComp,
    AutocompleteComp,
    visorSomosHabiles: () =>
      import("./components/visorSomosHabilesEstudiante.vue"),
  },

  data: () => ({
    paramComponente: { id_submodulo: 63, id_modulo: 7 },
    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,
    URL_SPACE: BUCKET_ORIGIN_SPACE,
    usedCodes: [], // VARIABLE GENERA CODIGOS ALETARIOS PARA EXAMEN SOMOS HABILES
    // consulta principal
    inhabilitarCursoAlum: true,
    MisclasesAlumnoHeader,
    seccion: "",
    filtroProgAlum: [],
    areaAlumno: [],
    cursoAlumno: [],
    cursoAlumFilter: [],
    progAlumno: [],
    progAlumnoFilter: [],
    search: "",
    // modal visor de contenidos
    compName: "",
    estadoModalConfig: false,
    parametroConfigVisor: [],
    compName2: null,
    visor: false,
    api_list_contenidos: [],
    tipoVisor: "",
    arrayPreguntasClaseSH: [],
    snackbarGlobal: false,
    colorsnackbarGlobal: "green",
    timeout: 2000,
    textAlertGlobal: "",
    UsuarioSomosHabiles: [],
    idexamenValor: null,
    compNameDialog: "",
    estadoComponente: true,
    parametroComp: [],
    seccionReporte: "",
    message: '',
      messages: [],
      socket: null,
  }),

  computed: {
    ...mapGetters({
      componenteEvento: 'login/componenteEvento',
    }),
    idclaseRouter() {
      return this.$route.params.value;
    },
    filteredData() {
      const searchTerm = this.search.toLowerCase();
      if(this.progAlumno.length != 0){
        
        console.log("aluuu",this.progAlumno)
        const filteredItems = this.progAlumno.filter(item => {
          return (
            item.nombre_apellido_doc.toLowerCase().includes(searchTerm) ||
            item.desc_curso.toLowerCase().includes(searchTerm) ||
            item.nombre_tema.toLowerCase().includes(searchTerm) ||
            item.nombre_clase.toLowerCase().includes(searchTerm) ||
            item.fecha.toLowerCase().includes(searchTerm) ||
            item.hora_inicio.toLowerCase().includes(searchTerm) ||
            item.hora_fin.toLowerCase().includes(searchTerm) ||
            item.desc_estado.toLowerCase().includes(searchTerm) 
          );
        });    
  
        return filteredItems;
      }
      return [];
    },
  },
  mounted() {
    this.getSeccion();
    this.loadMain();
    this.socket = io(API_URL);
    this.socket.on('examenActualizado', () => {
        this.loadMain(); 
    });
    this.cacudaSomosHabiles();

  },
  beforeDestroy() {
    this.socket.off('examenActualizado');
    this.socket.disconnect();
  },
  created() {
    this.actualizarParamentro();

  },
  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ...mapActions("login", ["parametroComponente"]),
    ...mapMutations("progDocente", ["setActivarCalendario"]),
    sendMessage() {
      if (this.message.trim() !== '') {
        this.socket.send(this.message);
        this.message = '';
      }
    },
    /** 
     ______________________________________________________
    |          MÉTODO INICIAR VALORES DEL ROUTER         */
    initValueRouter() {
      //LOGICA SIMULADOR CON CLASE
      if (!this.idclaseRouter) {
        return false;
      }
      if(this.progAlumno.length != 0) {

        this.progAlumno = this.progAlumno.filter(
          (objeto) => objeto.id_clase == this.idclaseRouter
        );
      }

      this.visualizarClase(this.idclaseRouter,
        this.progAlumno[0]["tipo_contenido"]
      );
    },
    /** 
     __________________________________________________________________________________
    |          MÉTODO ACTUALIZA EN UNA HORA DETERMINADA LAS CLASES DEL ALUMNO        */
    cacudaSomosHabiles() {
      const now = new Date();
      // let targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 13, 31, 10); 
      let targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 10); 

      if (now > targetTime) {
        targetTime.setDate(targetTime.getDate() + 1); 
      }

      const timeoutDuration = targetTime - now; 

      setTimeout(() => {
        this.loadMain(); 
        this.cacudaSomosHabiles(); 
      }, timeoutDuration);
    },
    /** 
     _________________________________________________
    |          MÉTODO ACTUALIZAR PARAMETROS         */
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    /** 
     ___________________________________
    |          MÉTODO INICIAL         */
    async loadMain() {

      try {
        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        //console.log("params:",params)
        let response = await axios.get(
          `/academico/alumnoClase/getQuery${params}`,
          {
            params: {
              search: this.search,
            },
          }
        );
        const { data } = response;
        if(data.messageT != 'E'){
        this.filtroProgAlum = [];
        this.seccion = this.seccionReporte;
        this.areaAlumno = data.payload.AlumnoArea;
        this.cursoAlumno = data.payload.AlumnoCurso;
        this.progAlumno = data.payload.AlumnoClase.map((e,i) => {
          
          return {...e,id:e.id+''+i}
        
        });

        this.progAlumnoFilter = data.payload.AlumnoClase;

        this.initValueRouter();
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
        //console.log(error)
      }
    },
    // REPORTE
    async generarReporteSemanalSh(){
 
      try {
        await axios.get(`/academico/alumnoClase/reporteSemanalSh`);

      } catch (error) {
        console.log(error)
      }

    },
    /** 
     ___________________________________________
    |          MÉTODO OBTENER SECCION         */
    async getSeccion() {
      const personaId = {
        id_persona: this.datoLogin.id_persona,  // Asegúrate de que el valor sea el correcto
        id_ano_lectivo: this.datoLogin.id_ano_lectivo
      };

      try {
        const resultado = await axios.post(`academico/alumnoClase`, personaId);
        
        this.seccionReporte = resultado.data[0].id_seccion
      } catch (error) {
        console.log(error)
      }

    },
    /** 
     __________________________________________
    |          MÉTODO VALIDAR ENLACE         */
    validarEnlace(enlaceVirtual, fechaClase, horaInicio, horaFin,) {
      var mensaje = "";
      var error = 0;
      /////// FUNCION PARA TRAER FECHA ACTUAL
      function ckeckTime(i) {
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      }
      let fechaActual = moment().format("YYYY-MM-DD");

      if (fechaActual > fechaClase) {
        mensaje = "La Clase ya culminó";
        error = 1;
      } else if (fechaActual < fechaClase) {
        mensaje = "La Clase no ha iniciado";
        error = 1;
      } else {
        let hora = new Date();
        let horaHora = ckeckTime(hora.getHours());
        let horaMin = ckeckTime(hora.getMinutes());
        let horaActual = `${horaHora}:${horaMin}:00`;

        if (horaActual < horaInicio) {
          mensaje += "La Clase no ha iniciado";
          error = 1;
        }

        if (horaActual > horaFin) {
          mensaje += "La Clase ya culminó";
          error = 1;
        }
      }

      if (error == 0) {
        //this.setEnviarMens({tipo:"S", mensaje: `Activar Link`, tiempo:null})
        window.open(enlaceVirtual);
      } else {
        this.setEnviarMens({ tipo: "E", mensaje: `${mensaje}`, tiempo: null });
      }
    },
    /** 
     _______________________________________________
    |          MÉTODO CAMBIAR AREA ALUMNO         */
    eventAreaAlum() {
      this.inhabilitarCursoAlum = false;
      if(this.cursoAlumno.length != 0) {
        
        this.cursoAlumFilter = this.cursoAlumno.filter(
          (el) => el.id_area == this.filtroProgAlum.id_area
        );
      }
    },
    /** 
     ________________________________________________
    |          MÉTODO CAMBIAR CURSO ALUMNO         */
    eventCursoAlum() {
      if(this.progAlumnoFilter.length != 0){
        this.progAlumno = this.progAlumnoFilter.filter(
          (el) => el.id_curso == this.filtroProgAlum.id_curso
        );
      }
    },
    /** 
     __________________________________________
    |          MÉTODO VER CALENDARIO         */
    verCalendario() {
      this.setActivarCalendario({ periodo: "", id_docente: "" });
    },
    // Generar reporte de Horario de clases
    /** 
     ________________________________________________________
    |          MÉTODO GENERAR REPORTE DE HORARIOS          */
    async generarExcel() {
      try {
        // this.generandoReporte = 1
        if (this.seccion == null || this.seccion == "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No tiene una sección asociada o no tiene clases programadas.",
            tiempo: 3000,
          });
          // this.generandoReporte = 0
          return false;
        }
        this.setEnviarMens({
          tipo: "S",
          mensaje: "Generando reporte…",
          tiempo: 3000,
        });

        let data = {};
        let archivoADescargar = "";

        data = {
          anioLectivo: parseInt(this.datoLogin.id_ano_lectivo),
          seccion: parseInt(this.seccion),
          colegio: parseInt(this.datoLogin.id_colegio),
          codigoReporte: "horario_seccion",
          tamanioPorHoja: 50,
          BUCKET_ORIGIN_SPACE: this.URL_SPACE,
        };

        //generamos el reporte
        let response = await axios.post(
          "/reporte/formatoReporte/generarReporte",
          data
        );
        let dataResponse = response.data;

        this.setEnviarMens({
          tipo: dataResponse.messageT,
          mensaje: dataResponse.message,
          tiempo: 3000,
        });
        this.generandoReporte = 0;
        if (dataResponse.messageT == "S") {
          archivoADescargar = dataResponse.fileToDownload;
          axios({
            url:
              "/reporte/formatoReporte/bajarReporte/" + dataResponse.nameReport,
            method: "GET",
            responseType: "blob", // important
          }).then((response) => {
            this.setEnviarMens({
              tipo: "S",
              mensaje: "¡Descargando reporte.!",
              tiempo: 3000,
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", archivoADescargar);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          });
        }
      } catch (e) {
        // this.generandoReporte = 0
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "No se pudo generar el reporte. Por favor, vuelva a intentarlo.",
          tiempo: 3000,
        });
      }
    },
    /** 
     ______________________________________________________________________________
    |          MÉTODO VISUALIZASR CLASES DE LA PROGRAMACION DE CONTENIDO         */
    async visualizarClase(id_clase, tipo_contenido) {

      this.parametroComp = {
        id_clase,
        evento: "view",
        miniatura: false,
        id_diapositiva: 1,
        tipo_contenido: tipo_contenido == 1 ? "manager" : "administrativo"
      }

      this.compNameDialog = "VisorContenido"
      this.estadoComponente = true

    },
    /** 
     _________________________________________________________
    |          MÉTODO VALIDAR USUARIO SOMOS HÁBILES         */
    async visualizarSomosHabiles(item) {

      let URI;
      if (item.tipo_contenido == 0) {
        URI = `/simulador/simuladorExamenColegio/simuladorAdmPreguntas/simuladorAdmP/validarAdmUsuarioSomosHabiles/${item.id_usuario}/${item.id_clase}`
      } else {
        URI = `/simulador/simuladorExamen/simuladorPreguntas/simuladorP/validarUsuarioSomosHabiles/${item.id_usuario}/${item.id_clase}`
      }

      try {

        const { data: response } = await axios.get(
          URI
        );

        if (Object.keys(response).length > 0) {
          if (response.estado) {

              let resultado = response.duracion;
              if (response.fecha_inicio) {     

                const fechaFin = new Date(Date.now()).toISOString();
                const fechaInicio_diferencia =  new Date(response.fecha_inicio)
                const fechaFin_diferencia = new Date(fechaFin);
                const diferenciaEnMilisegundos = fechaFin_diferencia - fechaInicio_diferencia;
                const segundos = Math.floor(diferenciaEnMilisegundos / 1000);
                const minutos = Math.floor(segundos / 60);
                const horas = Math.floor(minutos / 60);
                const segundosRestantes = segundos % 60;
                const minutosRestantes = minutos % 60;
                const tiempoUsado = `${horas.toString().padStart(2, '0')}:${minutosRestantes.toString().padStart(2, '0')}:${segundosRestantes.toString().padStart(2, '0')}`;  

                  if (tiempoUsado > "00:30:00") { //PUEDE SER DINAMICO EN EL FUTURO      
                    resultado = null;

                    this.snackbarGlobal = true;
                    this.colorsnackbarGlobal = "warning";
                    this.textAlertGlobal = "Se agotó el tiempo para realizar el SOMOS HÁBILES";  

                    await axios.put(`/simulador/simuladorExamen/simuladorExamenes/simuladorE/verificarCaducidad/${response.idexamen}/${item.tipo_contenido}`);                  
                    this.loadMain();
                    return false;

                  } else {                
                    resultado = this.restarHoras(response.duracion,  tiempoUsado);                
                    // resultado = null;                
                  }
              }
                  this.parametroComp = {
                      event: "view_somosHabiles",
                      items: response,
                      datos: item,
                      tipo_contenido: item.tipo_contenido,
                      tiempo_en_uso: resultado
                  };
                  this.compNameDialog = "visorSomosHabiles";
                  this.estadoComponente = true;  
          }else{            
            this.snackbarGlobal = true;
            this.colorsnackbarGlobal =  item.fecha_inicio_examen ? "warning":"red";
            this.textAlertGlobal = item.fecha_inicio_examen ? "Ya realizaste el SOMOS HÁBILES": "SOMOS HÁBILES caducado";
          }
        }else{
            this.snackbarGlobal = true;
            this.colorsnackbarGlobal = "red";
            this.textAlertGlobal = "No existe un examen de SOMOS HÁBILES.";
        }
      } catch (error) {
        console.log(error);
      }
    },
    restarHoras(horaInicio, horaFin) {
      let [h1, m1, s1] = horaInicio.split(':').map(num => parseInt(num, 10));
      let [h2, m2, s2] = horaFin.split(':').map(num => parseInt(num, 10));
      let totalSegundosInicio = h1 * 3600 + m1 * 60 + s1;
      let totalSegundosFin = h2 * 3600 + m2 * 60 + s2;
      let diferencia = totalSegundosInicio - totalSegundosFin;
      let h = Math.floor(diferencia / 3600).toString().padStart(2, '0');
      let m = Math.floor((diferencia % 3600) / 60).toString().padStart(2, '0');
      let s = (diferencia % 60).toString().padStart(2, '0');
      return `${h}:${m}:${s}`;
    },

    /** 
     _________________________________________________
    |          MÉTODO GENERAR CODIGO RANDOM         */
    generateRandomCode(length) {
      // debugger;
      let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let code = "";

      while (code.length < length) {
        let randomChar = characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
        code += randomChar;
      }

      if (this.usedCodes.includes(code)) {
        // If the code is already used, generate a new one recursively
        return this.generateRandomCode(length);
      }

      this.usedCodes.push(code);
      return code;
    },
    /** 
     ________________________________________
    |          MÉTODO CERRAR MODAL         */
    CloseModal() {
      this.estadoComponente = false;
      this.loadMain();
    },   
    /** 
     ________________________________________
    |          MÉTODO CERRAR MODAL         */
    cerrarVisor() {
      this.visor = false;
      this.api_list_contenidos = [];
      this.tipoVisor = "";
      //this.setCloseVisor()
    },
  },
};
</script>
